var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheckGray = function SvgCheckGray(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 800,
    height: 800,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#BFBFBF",
    d: "M1.25 12C1.25 6.063 6.063 1.25 12 1.25S22.75 6.063 22.75 12 17.937 22.75 12 22.75 1.25 17.937 1.25 12"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M16.53 8.97a.75.75 0 0 1 0 1.06l-4.626 4.627a1.75 1.75 0 0 1-2.475 0l-1.96-1.96a.75.75 0 0 1 1.061-1.06l1.96 1.959a.25.25 0 0 0 .353 0L15.47 8.97a.75.75 0 0 1 1.06 0"
  }))));
};
export default SvgCheckGray;